import { render, staticRenderFns } from "./formpay.vue?vue&type=template&id=cac38254&scoped=true&"
import script from "./formpay.vue?vue&type=script&lang=js&"
export * from "./formpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac38254",
  null
  
)

export default component.exports